import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class JsonGettersService {
  sessionLimiters: any;

  constructor(private http: HttpClient) {}

  getComplexityLimiters(): Observable<any> {
    return this.http.get('/assets/ux-ui-configuration/complexity-limiters.json').pipe(
      map(data => {
        this.sessionLimiters = data;
        return data;
      })
    );
  }
}
